import React, { useState } from "react";
import { toast } from "sonner";
import { schApi, schErr } from "@/lib/schApi";
import { btnGold, btnRed, field } from "@/components/nds/windows/finance/parts";
import PeoplePicker from "@/components/nds/windows/sch/PeoplePicker";

/** Create / edit a day task (no time) for staff and/or partners. */
export default function TaskForm({ meta, task, date, onClose, onSaved }) {
  const [f, setF] = useState(() => ({ title: task?.title || "", date: task?.date || date, notes: task?.notes || "", staff_ids: task?.staff_ids || [], partner_ids: task?.partner_ids || [] }));
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setBusy(true);
    try {
      if (task) {
        await schApi.patch(`/tasks/${task.id}`, { title: f.title, notes: f.notes, staff_ids: f.staff_ids, partner_ids: f.partner_ids });
        if (f.date !== task.date) await schApi.post(`/tasks/${task.id}/move`, { date: f.date });
      } else await schApi.post("/tasks", f);
      toast.success(task ? "Task saved" : "Task added");
      onSaved();
    } catch (e) { toast.error(schErr(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="sch-task-form" className="p-4 text-white">
        <div className="space-y-3">
          <input data-testid="sch-task-form-title" className={`${field} w-full`} placeholder="What needs doing?" value={f.title} onChange={(e) => set("title", e.target.value)} />
          <label className="text-xs text-nex-muted block">Day<input type="date" data-testid="sch-task-form-date" disabled={task?.status === "done"} className={`${field} w-full mt-1 disabled:opacity-50`} value={f.date} onChange={(e) => set("date", e.target.value)} />
            {task?.status === "done" && <span className="block mt-1 text-[11px]">Done tasks stay on their day — untick it first to move it.</span>}</label>
          <textarea data-testid="sch-task-form-notes" rows={2} className={`${field} w-full`} placeholder="Notes (optional)" value={f.notes} onChange={(e) => set("notes", e.target.value)} />
          <div className="grid sm:grid-cols-2 gap-2">
            <PeoplePicker label="Staff" testid="sch-task-form-staff" people={meta.staff} value={f.staff_ids} onChange={(v) => set("staff_ids", v)} />
            <PeoplePicker label="Partners" testid="sch-task-form-partners" people={meta.partners} value={f.partner_ids} onChange={(v) => set("partner_ids", v)} />
          </div>
          <div className="flex gap-2">
            <button type="button" disabled={busy || !f.title.trim() || !f.date} onClick={save} data-testid="sch-task-form-save" className={btnGold}>{busy ? "Saving…" : task ? "Save task" : "Add task"}</button>
            <button type="button" onClick={onClose} data-testid="sch-task-form-cancel" className={btnRed}>Cancel</button>
          </div>
        </div>
    </div>
  );
}
